module.exports = __webpack_public_path__ + "img/政策合集.2340e574.png";